<template>
	<div class="pallet-teaser">
		<div class="row justify-center relative-position">
			<q-img v-if="teaserImage"
				   class="col-12 col-md-auto log-teaser-image"
				   :src="teaserImage"
				   :alt="palletNo"
				   style="width: 100%;"
				   position="50% 100%"
				   ratio="2.666666666666667"
				   contain
			/>
			<q-img v-else
				   class="col-12 col-md-auto log-teaser-image"
				   :src="fallbackImagePath"
				   :alt="palletNo"
				   style="width: 100%;"
				   ratio="2.666666666666667"
			>
				<div class="absolute-full text-subtitle2 flex flex-center">
					{{ $t('previewImageUnavailable') }}
				</div>
			</q-img>
			<slot/>
		</div>

    <div class="q-px-md">
      <h5>{{ name }}</h5>
      <span class="subheading">{{ speciesName }}</span>
      <p class="text-secondary" v-if="unavailable">{{ $t('palletUnavailable.short') }}</p>
    </div>
	</div>
</template>

<script>
	import Teaser from "@/mixins/Teaser";

	export default {
		name: "PalletTeaser",
		mixins: [Teaser],
		props: ['pallet', 'name'],
	}
</script>

<style lang="scss" scoped>
	.pallet-teaser {
		cursor: pointer;

		h5 {
			color: var(--q-color-primary);
		}
	}
</style>